import React, { HTMLAttributes } from 'react';
import clsx from 'clsx';
import { CardEventRules } from '../../../common/enums/common';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  theme: string;
  displayrule?:CardEventRules;
  currentEvent?:CardEventRules;

}

const Card = ({ className, theme, displayrule,currentEvent, ...props }: CardProps): JSX.Element => {

  return (
    <>
    {
      (displayrule === CardEventRules.NORULES || (currentEvent === CardEventRules.SIGNEDOUTUSER && displayrule === CardEventRules.SIGNEDOUTUSER) || 
      (currentEvent  ===  CardEventRules.SIGNEDUSER && displayrule === CardEventRules.SIGNEDUSER)|| !displayrule) &&
     <div
      className={clsx(
        className,
        {
          'card-ocean': theme === 'card-ocean',
          'card-snow': theme === 'card-snow',
          'card-blue': theme === 'card-blue',
          'card-yellow': theme === 'card-yellow',
          'card-grey': theme === 'card-grey',
          'card-sky': theme === 'card-sky',
          'card-trans-white': theme === 'card-trans-white',
          'card-inky': theme === 'card-inky',
        },
        'flex p-md bg-card-fill'
      )}
      {...props}
      data-testid="card-test"
    />}
    </>
  
)};

export default Card;
